import { MessageCircle, Instagram, Youtube } from 'lucide-react';
import TikTokIcon from '../components/icons/TikTokIcon';

// Source unique des réseaux officiels MonAlerte, utilisée par la page
// Communauté (grille détaillée) et le Footer (icônes rapides).
export const socialNetworks = [
  {
    id: 'whatsapp',
    name: 'WhatsApp Co-création',
    category: 'Messagerie & Échanges',
    url: 'https://chat.whatsapp.com/KSljOanAu6M8aE2PFyT9nF',
    description: 'Rejoignez le groupe officiel des bêta-testeurs. Échangez en direct avec le créateur et donnez votre avis sur les évolutions.',
    badge: 'Canal Officiel Actif',
    color: '#25D366',
    icon: MessageCircle,
    buttonText: 'Rejoindre sur WhatsApp'
  },
  {
    id: 'instagram',
    name: 'Instagram',
    category: 'Prévention & Communauté',
    url: 'https://www.instagram.com/monalerte.app/',
    description: 'Retrouvez nos conseils de sécurité au quotidien, infographies pédagogiques et les coulisses du projet citoyen.',
    badge: 'Canal Officiel Actif',
    color: '#E4405F',
    icon: Instagram,
    buttonText: 'Suivre sur Instagram'
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    category: 'Vidéos Courtes & Astuces',
    url: 'https://www.tiktok.com/@monalerte',
    description: 'Démonstrations rapides, astuces de sécurité et coulisses du développement en format court.',
    badge: 'Canal Officiel Actif',
    color: '#00F2EA',
    icon: TikTokIcon,
    buttonText: 'Suivre sur TikTok'
  },
  {
    id: 'youtube',
    name: 'YouTube',
    category: 'Vidéos & Démonstrations',
    url: 'https://www.youtube.com/@monAlerte',
    description: 'Démonstrations des fonctionnalités en vidéo, tutoriels de prise en main et interventions sur la sécurité.',
    badge: 'Canal Officiel Actif',
    color: '#FF0000',
    icon: Youtube,
    buttonText: "S'abonner sur YouTube"
  }
];

export default socialNetworks;
